(() => {
  if (customElements.get('carson-brochure-downloads')) return;

  class CarsonBrochureDownloads extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.addEventListener('click', (event) => this.handleClick(event));
    }

    async handleClick(event) {
      const link = event.target.closest('[data-brochure-download]');

      if (!link || !this.contains(link)) return;

      event.preventDefault();

      const fileUrl = link.href;

      try {
        const response = await fetch(fileUrl);

        if (!response.ok) {
          throw new Error(`Brochure request failed with status ${response.status}`);
        }

        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');

        downloadLink.href = objectUrl;
        downloadLink.download = this.getFileName(fileUrl);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();

        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0);
      } catch (error) {
        console.error('Brochure download failed. Opening the original file URL instead.', error);
        window.location.assign(fileUrl);
      }
    }

    getFileName(fileUrl) {
      try {
        const url = new URL(fileUrl, window.location.href);
        const fileName = url.pathname.split('/').pop();

        return decodeURIComponent(fileName || 'download');
      } catch (_error) {
        return fileUrl.split('/').pop().split('?')[0] || 'download';
      }
    }
  }

  customElements.define('carson-brochure-downloads', CarsonBrochureDownloads);
})();
